/*
 * Preisfilter (von/bis): reines Durchtabben löst keinen Auto-Reload mehr aus.
 *
 * Ursache (empire.js, Theme-Kern): die Preisfilter-Inputs lauschen auf
 * 'keyup' und starten dabei einen 2s-Timer, der die Seite mit den
 * Filter-Query-Params neu lädt. 'keyup' feuert bei JEDER Taste, auch bei
 * Tab - Tastatur-Nutzer, die nur durch die Felder tabben, ohne etwas
 * einzugeben, lösten so ungewollt einen Seiten-Reload aus und wurden aus
 * dem Tab-Fluss geworfen.
 *
 * Fix: Der Tab-Keyup wird per Event-Capturing auf einer Ebene über dem
 * Input abgefangen, bevor er den 'keyup'-Handler des Themes erreicht.
 * Echtes Tippen einer Zahl (jede andere Taste) lässt den Auto-Filter
 * unverändert wie gewohnt auslösen.
 */
document.addEventListener(
  'keyup',
  function (e) {
    if (
      e.key === 'Tab' &&
      e.target.closest &&
      e.target.closest('.collection-filters__filter-range-input')
    ) {
      e.stopPropagation();
    }
  },
  true
);

/*
 * Kategorieseiten: Kachelbilder mit mehr Vorlauf laden (Tablet-Fix).
 *
 * Ausgangslage: Kachelbilder werden vom Theme nicht über natives
 * loading="lazy" gesteuert (das steht zwar zusätzlich auf dem <img>, greift
 * hier aber praktisch nicht, weil das anfängliche srcset - ein
 * Platzhalter-SVG - den src-Fallback ohnehin verdrängt). Die eigentliche
 * Ladeschwelle setzt das im Theme gebündelte @pixelunion/rimg-shopify
 * (empire.js): ein fest verdrahteter IntersectionObserver mit
 * rootMargin "20% 0px". Auf dem Tablet ist das bei schnellem Wischen zu
 * spät - man sieht kurz leere Kacheln, bevor sie nachladen.
 *
 * Fix: Ein zusätzlicher IntersectionObserver mit größerem Vorlauf
 * (LAZYLOAD_ROOT_MARGIN) beobachtet dieselben Kachelbilder
 * (`[data-rimg="lazy"]`) und ersetzt deren Platzhalter früher durch eine
 * Vorschau in der aktuell dargestellten Größe. Der Status
 * (`data-rimg="lazy"`) bleibt dabei unverändert, sodass rimg's eigener
 * Observer die Kachel beim tatsächlichen Erreichen des Viewports weiterhin
 * ganz normal übernimmt und durch die dichte-korrekte Endgröße ersetzt.
 * Beide Mechanismen laufen über dieselben data-rimg-* Attribute und
 * vertragen sich daher konfliktfrei - empire.js und die Produkt-Templates
 * bleiben unangetastet.
 *
 * Scope: nur Kategorieseiten (.collection--section .productgrid--items),
 * damit Suche, Startseite, Recently-Viewed und Compare unberührt bleiben.
 * Die erste Bilderreihe liefert das Theme bereits eager aus (kein
 * data-rimg="lazy") und wird hier folglich gar nicht erst angefasst.
 *
 * Fallback ohne JS oder ohne IntersectionObserver: das vom Theme gesetzte
 * native loading="lazy" bzw. der eingebaute rimg-Observer bleiben
 * unverändert bestehen - es ändert sich nichts am bisherigen Verhalten.
 *
 * Bugfix (Doppel-Request bei 8/29 Kacheln): Die zuvor hier verwendete
 * Größenberechnung (getBoundingClientRect * devicePixelRatio, pro Achse
 * unabhängig gerundet) weicht von der Berechnung ab, die rimg-shopify
 * selbst beim späteren echten Laden durchführt - u.a. weil rimg mit
 * offsetWidth/offsetHeight statt getBoundingClientRect arbeitet und bei
 * unbeschnittenen Bildern (kein data-rimg-crop) eine Achse anhand des
 * *Bild*-Seitenverhältnisses (data-rimg-max, das Originalbild) aus der
 * anderen ableitet, statt beide Achsen unabhängig vom Container zu lesen.
 * Dadurch entstand z.B. 137x195 (unsere Vorschau) vs. 137x196 (rimg) -
 * zwei fast identische, aber unterschiedliche URLs, die beide geladen
 * wurden. Es gibt in rimg-shopify keinen öffentlichen Weg, seinen eigenen
 * Loader für ein einzelnes Element vorzeitig auszulösen (nur ein
 * Custom-Event für "watch", das den bestehenden 20%-Vorlauf nicht
 * überschreibt) - daher portieren wir seine Größenlogik 1:1 hierher,
 * statt sie neu zu erfinden. Quelle:
 * node_modules/@pixelunion/rimg-shopify/dist/index.es.js (v2.7.1),
 * Funktionen getElementSize/supportedDensity/roundSize/setImage.
 * Die Rundung (RIMG_ROUND) muss dem Init-Aufruf in empire.js entsprechen
 * (initEmpire(): `.init('[data-rimg="lazy"]', { round: 1 })`), da unsere
 * Bilder kein eigenes data-rimg-round-Attribut setzen (snippets/rimg.liquid).
 *
 * Stufe 2 (Hintergrund-Nachladen): Stufe 1 lädt nur Kacheln vor, die sich
 * dem Viewport nähern - Kacheln weit unterhalb (z. B. am Ende einer langen
 * Kategorieseite) bleiben bis zum Scrollen unberührt. Sobald die Seite
 * fertig geladen und der Browser idle ist (requestIdleCallback, Fallback
 * setTimeout ~1500ms nach load), werden die verbleibenden Kacheln trotzdem
 * im Hintergrund nachgeladen, gestaffelt in kleinen Batches, damit weder
 * das initiale Rendern/LCP noch die Netzwerk-/CPU-Last am Stück leiden.
 * Dieselbe preload()-Funktion (= dieselbe portierte rimg-Größenlogik) wird
 * wiederverwendet, damit auch hier keine Doppel-Requests entstehen.
 *
 * Bugfix (nur ~5 statt ~48 Requests trotz korrekt gesetztem srcset): Kacheln
 * jenseits der ersten Reihe tragen zusätzlich natives loading="lazy"
 * (product-grid-item.liquid, native_lazy_attr). Das steuert den Byte-Fetch
 * unabhängig von unserem srcset weiterhin über einen browsereigenen, viel
 * engeren Abstand zum Viewport - unser frühzeitig gesetztes srcset wurde
 * also zwar korrekt hinterlegt, aber der eigentliche Download blieb bis
 * dahin trotzdem aus (img.complete=false, naturalWidth=0). preload() setzt
 * daher vor dem srcset zusätzlich `img.loading = 'eager'`, um den nativen
 * Mechanismus für bereits vorgeladene Kacheln abzuschalten.
 *
 * Bugfix (8 Kacheln in zwei deutlich verschiedenen Größen, z.B. 261x350 und
 * 146x196): Das ist keine Rundungsdifferenz, sondern ein Layout-Zustand vor
 * vs. nach dem endgültigen Reflow (z.B. bevor die Rasterspalten ihre finale
 * Breite haben) - preload() maß offsetWidth/-Height zu einem Zeitpunkt, an
 * dem sich das Layout noch ändern konnte, insbesondere direkt nach `load`
 * (Stufe 2) oder sobald eine Kachel früh im Vorlauf-Fenster von Stufe 1
 * liegt. preloadWhenStable() vergleicht die Größe daher über zwei
 * aufeinanderfolgende requestAnimationFrame-Ticks und lädt erst, wenn sie
 * unverändert bleibt; Stufe 2 wartet zusätzlich nach dem Idle-Trigger einen
 * doppelten rAF ab, bevor sie überhaupt zu messen beginnt.
 *
 * Bugfix (Bilder geladen, aber Platzhalter-Overlay bleibt sichtbar): rimg
 * blendet sein [data-rimg-canvas]-Overlay rein per CSS aus, ausgelöst durch
 * data-rimg="loaded" auf dem <img> (siehe theme.css.liquid). Da unser
 * eigenes Vorladen den Status bewusst auf "lazy" belässt (siehe oben), blieb
 * das Overlay stehen, obwohl das Bild längst fertig geladen war. preload()
 * ruft daher nach dem Setzen von srcset zusätzlich markLoadedWhenReady()
 * auf, das erst nach abgeschlossenem Laden (img.decode(), Fallback
 * load-Event) denselben "loaded"-Zustand herstellt, den rimg's eigenes
 * loadFullImage() auch setzt - nie vorher, und bei Ladefehlern gar nicht.
 */
(function () {
  // Vorlauf in Pixel, bevor eine Kachel den Viewport erreicht.
  // Zum Nachjustieren zwischen 500 und 1200px anpassen.
  var LAZYLOAD_ROOT_MARGIN = '800px 0px';

  var IMG_SELECTOR = '.collection--section .productgrid--items img[data-rimg="lazy"]';

  // Muss mit der Rundung übereinstimmen, mit der empire.js rimg-shopify
  // initialisiert (siehe Kommentar oben).
  var RIMG_ROUND = 1;

  var CROP_VALUES = ['top', 'center', 'bottom', 'left', 'right'];

  if (!('IntersectionObserver' in window)) {
    return;
  }

  // Portiert aus rimg-shopify: rundet auf ein Vielfaches von `multiple` auf
  // (Math.ceil) und deckelt bei `maxLimit` (der Originalbildgröße).
  function roundSize(size, multiple, maxLimit) {
    if (size === 0) return multiple;
    return Math.min(Math.ceil(size / multiple) * multiple, maxLimit);
  }

  // Portiert aus rimg-shopify: läuft den DOM-Baum hoch, bis ein Element mit
  // beiden Achsen > 20px gefunden wird (offsetWidth/-Height, nicht
  // getBoundingClientRect - rimg tut dies exakt so).
  function getElementSize(el) {
    var width = 0;
    var height = 0;
    while (el) {
      width = el.offsetWidth;
      height = el.offsetHeight;
      if (width > 20 && height > 20) break;
      el = el.parentNode;
    }
    return { width: width, height: height };
  }

  // Portiert aus rimg-shopify: maximal unterstützte Dichte, begrenzt durch
  // die Originalbildgröße und window.devicePixelRatio. Gibt (wie im Original)
  // einen mit toFixed(2) formatierten String zurück.
  function supportedDensity(maxWidth, maxHeight, width, height, density) {
    return Math.min(
      Math.min(Math.max(maxWidth / width, 1), density),
      Math.min(Math.max(maxHeight / height, 1), density)
    ).toFixed(2);
  }

  function preload(img) {
    // Wurde die Kachel inzwischen bereits vom Theme selbst geladen, nichts tun.
    if (img.getAttribute('data-rimg') !== 'lazy') return;

    var template = img.getAttribute('data-rimg-template');
    if (!template) return;

    var maxParts = (img.getAttribute('data-rimg-max') || '').split('x');
    var maxWidth = parseInt(maxParts[0], 10);
    var maxHeight = parseInt(maxParts[1], 10);
    if (!maxWidth || !maxHeight) return;

    var scale = parseInt(img.getAttribute('data-rimg-scale'), 10) || 1;
    var cropAttr = img.getAttribute('data-rimg-crop');
    var crop = CROP_VALUES.indexOf(cropAttr) !== -1 ? cropAttr : null;

    var elSize = getElementSize(img);
    var width = elSize.width * scale;
    var height = elSize.height * scale;
    if (!width || !height) return;

    var density = supportedDensity(maxWidth, maxHeight, width, height, window.devicePixelRatio || 1);
    var targetWidth = width * density;
    var targetHeight = height * density;
    var displayWidth;
    var displayHeight;

    if (crop) {
      displayWidth = roundSize(targetWidth, RIMG_ROUND, maxWidth);
      displayHeight = roundSize(targetHeight, RIMG_ROUND, maxHeight);
    } else {
      // Shopify liefert unbeschnittene Bilder passend zur kleineren Achse
      // aus; um die erwartete Dichte zu erhalten, muss die "cover"-Achse
      // anhand des Bild-Seitenverhältnisses (nicht des Container-
      // Seitenverhältnisses) bestimmt werden - siehe rimg-shopify setImage().
      var containerAspectRatio = width / height;
      var imageAspectRatio = maxWidth / maxHeight;

      if (containerAspectRatio > imageAspectRatio) {
        // fit width
        displayWidth = roundSize(targetWidth, RIMG_ROUND, maxWidth);
        displayHeight = roundSize(targetWidth / imageAspectRatio, RIMG_ROUND, maxHeight);
      } else {
        // fit height
        displayWidth = roundSize(targetHeight * imageAspectRatio, RIMG_ROUND, maxWidth);
        displayHeight = roundSize(targetHeight, RIMG_ROUND, maxHeight);
      }
    }

    // Natives loading="lazy" (von Kacheln jenseits der ersten Reihe, siehe
    // product-grid-item.liquid) verzögert den eigentlichen Byte-Fetch anhand
    // eines browsereigenen, viel engeren Abstands zum Viewport - unabhängig
    // davon, wann wir srcset setzen. Ohne diese Zeile bleibt img.complete
    // trotz korrektem srcset false, bis der Browser das Bild von sich aus
    // für "nah genug" hält. Muss VOR dem Setzen von srcset passieren, sonst
    // greift die Deaktivierung nicht mehr für den bereits angestoßenen Fetch.
    img.loading = 'eager';

    img.setAttribute(
      'srcset',
      template.replace('{size}', displayWidth + 'x' + displayHeight) + ' ' + density + 'x'
    );

    markLoadedWhenReady(img);
  }

  // rimg-shopify blendet sein Platzhalter-Overlay ([data-rimg-canvas], siehe
  // rimg.liquid) rein über CSS aus (theme.css.liquid):
  //   [data-rimg=loaded] + [data-rimg-canvas], [data-rimg=loaded] > [data-rimg-canvas] { opacity: 0; ... }
  // Ausgelöst wird das ausschließlich durch das data-rimg-Attribut selbst -
  // rimg's eigenes loadFullImage() setzt es nach erfolgreichem Laden exakt
  // auf "loaded" (siehe node_modules/@pixelunion/rimg-shopify, setImage()/
  // Image.onload). Solange wir bei unserem eigenen Vorladen "lazy" stehen
  // lassen, bleibt das Overlay sichtbar, obwohl das Bild längst da ist -
  // wir müssen also denselben Endzustand spiegeln, sonst wirkt die Kachel
  // weiterhin "ladend". Das Overlay selbst fassen wir nicht an, das erledigt
  // die vorhandene CSS-Regel automatisch.
  function markLoaded(img) {
    img.setAttribute('data-rimg', 'loaded');
  }

  // Nur nach tatsächlich erfolgreichem Laden umschalten (nie vorher, sonst
  // blitzt kurz eine leere/verdeckte Kachel auf) und bei einem Ladefehler
  // den Platzhalter unangetastet stehen lassen - identisch zu rimg's
  // eigenem Verhalten, das ebenfalls nur den Erfolgsfall (Image.onload)
  // behandelt und Fehler stillschweigend im "lazy"/"loading"-Zustand belässt.
  // img.decode() wartet zusätzlich das vollständige Dekodieren ab (nicht nur
  // den Netzwerk-Request), damit auch hier nichts unfertig aufblitzt.
  function markLoadedWhenReady(img) {
    if (typeof img.decode === 'function') {
      img.decode().then(
        function () {
          markLoaded(img);
        },
        function () {
          // Ladefehler: Platzhalter/Overlay bleiben stehen.
        }
      );
    } else {
      img.addEventListener('load', function onLoad() {
        img.removeEventListener('load', onLoad);
        markLoaded(img);
      });
    }
  }

  // Maximale Anzahl Frames, die auf ein stabiles Layout gewartet wird, bevor
  // trotzdem mit dem letzten Messwert vorgeladen wird (siehe preloadWhenStable).
  var MAX_STABILITY_ATTEMPTS = 8;

  // preload() verlässt sich auf offsetWidth/-Height (getElementSize) - wird
  // vor dem finalen Layout gemessen (z.B. bevor die Sidebar/Rasterspalten
  // ihre endgültige Breite haben), entsteht eine falsche, aber gültige
  // Vorschau-URL. rimg's eigener Loader lädt später mit der dann korrekten
  // Breite nach - zwei unterschiedliche, aber beide "richtig aussehende"
  // Größen (z.B. 261x350 statt 146x196), keine 1px-Rundungsdifferenz.
  //
  // Fix: Statt sofort zu laden, wird die Elementgröße über zwei
  // aufeinanderfolgende Frames verglichen. Erst wenn sie unverändert bleibt,
  // gilt das Layout als stabil und preload() wird aufgerufen. Ändert sie
  // sich weiterhin (z.B. weitere Reflows), wird erneut gewartet, bis
  // MAX_STABILITY_ATTEMPTS erreicht ist - dann wird mit dem letzten
  // Messwert fortgefahren, damit eine Kachel nicht dauerhaft unbeobachtet
  // bleibt, falls sich das Layout fortlaufend ändert (z.B. Animation).
  function preloadWhenStable(img, attempt) {
    attempt = attempt || 0;
    var before = getElementSize(img);

    requestAnimationFrame(function () {
      var after = getElementSize(img);
      var stable =
        (before.width === after.width && before.height === after.height) ||
        attempt >= MAX_STABILITY_ATTEMPTS;

      if (stable) {
        preload(img);
      } else {
        preloadWhenStable(img, attempt + 1);
      }
    });
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          observer.unobserve(entry.target);
          preloadWhenStable(entry.target);
        }
      });
    },
    { rootMargin: LAZYLOAD_ROOT_MARGIN }
  );

  function observeAll(root) {
    root.querySelectorAll(IMG_SELECTOR).forEach(function (img) {
      observer.observe(img);
    });
  }

  observeAll(document);

  // Theme-Editor rendert Sections per AJAX neu (shopify:section:load) -
  // neu eingefügte Kacheln ebenfalls beobachten.
  document.addEventListener('shopify:section:load', function (e) {
    observeAll(e.target);
  });

  // --- Stufe 2: Hintergrund-Nachladen aller restlichen Kacheln ---
  // Siehe Erklärung im Kopf-Kommentar dieser Datei.

  // Anzahl gleichzeitig nachgeladener Kacheln pro Batch.
  var IDLE_BATCH_SIZE = 4;

  function onIdle(callback) {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(callback);
    } else {
      setTimeout(callback, 300);
    }
  }

  function backgroundLoadRemaining() {
    var pending = [];
    document.querySelectorAll(IMG_SELECTOR).forEach(function (img) {
      if (img.getAttribute('data-rimg') === 'lazy') {
        pending.push(img);
      }
    });

    function processNextBatch() {
      var batch = pending.splice(0, IDLE_BATCH_SIZE);

      batch.forEach(function (img) {
        // Nicht mehr zusätzlich über Stufe 1 auslösen lassen.
        observer.unobserve(img);
        preloadWhenStable(img);
      });

      if (pending.length) {
        onIdle(processNextBatch);
      }
    }

    if (pending.length) {
      processNextBatch();
    }
  }

  function scheduleBackgroundLoad() {
    function start() {
      // Doppelter rAF: dem Layout nach dem load-Event mindestens einen
      // vollständigen Render-Zyklus geben, bevor überhaupt mit dem Messen
      // von Kachelbreiten begonnen wird (die einzelnen preloadWhenStable()-
      // Aufrufe unten sichern zusätzlich pro Kachel ab).
      requestAnimationFrame(function () {
        requestAnimationFrame(backgroundLoadRemaining);
      });
    }

    if ('requestIdleCallback' in window) {
      requestIdleCallback(start);
    } else {
      setTimeout(start, 1500);
    }
  }

  if (document.readyState === 'complete') {
    scheduleBackgroundLoad();
  } else {
    window.addEventListener('load', scheduleBackgroundLoad);
  }
})();

/*
 * Kategorieseiten: Rabatt-Pille vom Bild in den Textblock verschieben.
 *
 * Ausgangslage: Die Rabatt-Prozent-Pille (.productitem__badge--sale) wird
 * von snippets/product-badge.liquid im Bildbereich gerendert (absolut
 * positioniert auf der Figure, siehe custom.css). Sie soll stattdessen im
 * Textblock rechts neben den Preisblock (.productitem__price) stehen.
 * Bildbereich und Preisblock sind aber Geschwister-Container innerhalb von
 * .productitem__container (nicht verschachtelt) - CSS kann Elemente nur
 * innerhalb desselben Flex-/Grid-Containers umsortieren (z.B. per `order`),
 * nicht über Elterngrenzen hinweg verschieben. Daher hier eine gezielte
 * DOM-Verschiebung.
 *
 * Mobil-Ausnahme (< 768px): Mit einer Preisspanne ("ab 1.299,00 €") plus
 * Pille bei ~150px Kachel-Innenbreite bricht die Streichpreis-Zeile
 * nachweislich unschön um (in einer separaten Testseite mit den echten
 * custom.css-Werten geprüft). Deshalb bleibt die Pille unter 768px
 * unverändert im Bild, der Umzug greift erst ab Tablet aufwärts - aus
 * demselben Grund wandert auch die TOP-/Neu-Pille erst ab 768px nach oben
 * links (siehe custom.css), sonst würden sich beide Pillen auf dem Handy
 * in derselben Ecke überlappen.
 *
 * Reversibel per matchMedia-Listener: beim Über-/Unterschreiten von 768px
 * (Fenster-Resize, Tablet-Rotation) wird die Verschiebung sauber rückgängig
 * gemacht bzw. erneut angewendet, statt nur einmalig beim Laden zu greifen.
 *
 * Berührt die Bildmessung (preload() oben) nicht: Die Pille ist
 * position:absolute und nimmt im Bildbereich keinen Layout-Platz ein - ihr
 * Entfernen/Wiedereinfügen verändert die dort gemessene Container-Größe
 * des Bildes nicht.
 */
(function () {
  var TILE_SELECTOR =
    '.collection--section .productgrid--items .productitem, ' +
    '.product-recommendations--container[data-product-recommendations] .productitem';
  var ROW_CLASS = 'productitem__price-badge-row';
  var RECOMMENDATIONS_SELECTOR = '.product-recommendations--container[data-product-recommendations]';

  if (!('matchMedia' in window)) {
    return;
  }

  var mq = window.matchMedia('(min-width: 768px)');

  function relocate(tile) {
    if (tile.querySelector('.' + ROW_CLASS)) return; // bereits verschoben

    var badge = tile.querySelector('.productitem__image-container .productitem__badge--sale');
    var price = tile.querySelector('.productitem--info .productitem__price');
    if (!badge || !price) return;

    var row = document.createElement('div');
    row.className = ROW_CLASS;
    price.parentNode.insertBefore(row, price);
    row.appendChild(price);
    row.appendChild(badge);
  }

  function restore(tile) {
    var row = tile.querySelector('.' + ROW_CLASS);
    if (!row) return;

    var price = row.querySelector('.productitem__price');
    var badge = row.querySelector('.productitem__badge--sale');
    var figure = tile.querySelector('.productitem__image-container .productitem--image');

    if (price) row.parentNode.insertBefore(price, row);
    if (badge && figure) figure.appendChild(badge);
    row.parentNode.removeChild(row);
  }

  function apply(matchesDesktop, root) {
    root.querySelectorAll(TILE_SELECTOR).forEach(function (tile) {
      if (matchesDesktop) {
        relocate(tile);
      } else {
        restore(tile);
      }
    });
  }

  apply(mq.matches, document);

  if (mq.addEventListener) {
    mq.addEventListener('change', function (e) {
      apply(e.matches, document);
    });
  } else if (mq.addListener) {
    // Ältere Safari-Versionen ohne addEventListener auf MediaQueryList.
    mq.addListener(function (e) {
      apply(e.matches, document);
    });
  }

  // Theme-Editor rendert Sections per AJAX neu (shopify:section:load).
  document.addEventListener('shopify:section:load', function (e) {
    apply(mq.matches, e.target);
  });

  // Empfehlungs-Kacheln kommen erst per AJAX nach dem initialen apply()-Lauf
  // oben ins DOM (siehe StaticProductRecommendations.js in empire.js) -
  // ohne diesen Observer würde die Verschiebung für sie nie greifen. Gleiches
  // Muster wie der MutationObserver im Slider-Block weiter unten in dieser
  // Datei; relocate()/restore() prüfen den Ziel-Zustand vorab, daher ist es
  // unschädlich, apply() bei jeder Mutation im Container erneut aufzurufen
  // (auch wenn z.B. der Slider dort ebenfalls Buttons einfügt).
  document.querySelectorAll(RECOMMENDATIONS_SELECTOR).forEach(function (container) {
    var mo = new MutationObserver(function () {
      apply(mq.matches, container);
    });
    mo.observe(container, { childList: true, subtree: true });
  });
})();

/*
 * Kategorienavigation (Nachbarkategorien-Chips): "Mehr anzeigen" nur
 * einblenden, wenn auf dem Handy tatsächlich etwas abgeschnitten wird.
 *
 * Die Höhenbegrenzung selbst ist reines CSS (max-height + overflow: hidden
 * auf .category-nav__chips, siehe custom.css). Hier wird nur gemessen, ob
 * scrollHeight > clientHeight ist - dafür kurz in den eingeklappten Zustand
 * schalten (falls der Umschalter, z. B. per bfcache, schon offen war),
 * messen, Ausgangszustand wiederherstellen. Kein Layout-Sprung sichtbar, da
 * das innerhalb desselben Tasks passiert (Browser malt erst danach neu).
 */
(function () {
  var GROUP_SELECTOR = '[data-category-nav-chips-group]';
  var HAS_OVERFLOW_CLASS = 'category-nav__chips-group--has-overflow';

  function checkOverflow(root) {
    root.querySelectorAll(GROUP_SELECTOR).forEach(function (group) {
      var chips = group.querySelector('.category-nav__chips');
      var input = group.querySelector('.category-nav__toggle-input');
      if (!chips || !input) return;

      var wasChecked = input.checked;
      if (wasChecked) input.checked = false;

      var overflowing = chips.scrollHeight > chips.clientHeight + 1;

      if (wasChecked) input.checked = true;

      group.classList.toggle(HAS_OVERFLOW_CLASS, overflowing);
    });
  }

  checkOverflow(document);

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      checkOverflow(document);
    }, 150);
  });

  // Theme-Editor rendert Sections per AJAX neu (shopify:section:load).
  document.addEventListener('shopify:section:load', function (e) {
    checkOverflow(e.target);
  });
})();

/*
 * Produktempfehlungen ("Das könnte Ihnen auch gefallen"): eigener,
 * schlanker Desktop-Slider ab 1024px - kein Flickity.
 *
 * Kein eigener Lazyload-Code nötig: jede Empfehlungs-Kachel bekommt von
 * snippets/product-grid-item.liquid ohnehin data-rimg="lazy" (context !=
 * 'collection' -> performance_lazyload bleibt immer true), inklusive
 * Platzhalter-SVG im srcset (snippets/rimg.liquid) und [data-rimg-canvas]
 * -Overlay. rimg-shopify (in empire.js gebündelt) beobachtet diese Kacheln
 * bereits selbst per IntersectionObserver (20% rootMargin) und lädt/blendet
 * sie ein, sobald sie in die Nähe des Viewports kommen - exakt dieselbe
 * Mechanik, auf der auch der Kategorieseiten-Fix weiter oben in dieser
 * Datei aufbaut. Ein zweiter, eigener Observer auf denselben src/srcset-
 * Attributen hat hier nur mit rimgs eigenem Ladezyklus kollidiert (hängen
 * gebliebenes Canvas-Overlay, nach Resize nicht nachgeladene Bilder) und
 * wurde deshalb wieder entfernt.
 *
 * Warum kein Flickity: Der Mobile-Slider auf diesem Block (unter 1024px)
 * läuft bereits über Flickity, aber via ProductRowScroller.js in empire.js
 * gebündelt und dort nicht global verfügbar gemacht (kein window.Flickity,
 * kein jQuery-Plugin) - von außen (aus dieser Datei) lässt sich also keine
 * zweite Flickity-Instanz erzeugen, ohne empire.js anzufassen. Deshalb
 * native overflow-x/scroll-snap + eigene Pfeil-Buttons, NUR ab 1024px.
 *
 * Harte Grenze bei 1024px (dieselbe Schwelle, ab der ProductRowScroller
 * sein Flickity zerstört, siehe theme.css.liquid html::after-Breakpoints:
 * "L" = min-width 1024px): unterhalb dieser Breite fasst dieser Code weder
 * CSS (siehe custom.css) noch DOM der Kacheln an, die Buttons werden dort
 * gar nicht erst eingefügt. Vermeidet jede Kollision mit dem echten
 * Flickity-Betrieb von empire.js auf demselben [data-product-row]-Element.
 *
 * Pfeil-Optik: exakt die echten Flickity-Button-Klassen und das SVG-Markup
 * aus node_modules/flickity/js/prev-next-button.js (Version 2.2.0, wie im
 * Theme gebündelt) nachgebaut - keine eigene Grafik. Damit greifen
 * automatisch dieselben CSS-Regeln wie bei den Mobile-Pfeilen
 * (vendor.flickity.css + theme.css.liquid), optisch identisch, ohne dass
 * hier zusätzliches Button-Styling nötig ist.
 */
(function () {
  var CONTAINER_SELECTOR = '.product-recommendations--container[data-product-recommendations]';
  var ROW_SELECTOR = '[data-product-row]';
  var TILE_SELECTOR = '.productgrid--item';
  var OVERFLOW_TOLERANCE = 2;
  var SVG_NS = 'http://www.w3.org/2000/svg';
  // Pfad exakt nachgerechnet aus Flickity.defaults.arrowShape
  // { x0: 10, x1: 60, y1: 50, x2: 70, y2: 40, x3: 30 }.
  var ARROW_PATH = 'M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z';

  if (!('matchMedia' in window)) {
    return;
  }

  var desktopMq = window.matchMedia('(min-width: 1024px)');

  function createButton(direction) {
    var isPrevious = direction === 'previous';
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'flickity-button flickity-prev-next-button ' + direction;
    button.setAttribute('aria-label', isPrevious ? 'Vorherige Produkte' : 'Nächste Produkte');

    var svg = document.createElementNS(SVG_NS, 'svg');
    svg.setAttribute('class', 'flickity-button-icon');
    svg.setAttribute('viewBox', '0 0 100 100');

    var path = document.createElementNS(SVG_NS, 'path');
    path.setAttribute('class', 'arrow');
    path.setAttribute('d', ARROW_PATH);
    if (!isPrevious) {
      path.setAttribute('transform', 'translate(100, 100) rotate(180) ');
    }

    svg.appendChild(path);
    button.appendChild(svg);
    return button;
  }

  function setupSlider(row) {
    if (row.dataset.customSliderReady) return;
    row.dataset.customSliderReady = 'true';

    var prevBtn = null;
    var nextBtn = null;
    var scrollTicking = false;
    var resizeTimer = null;

    function step() {
      return Math.round(row.clientWidth * 0.8);
    }

    function updateButtons() {
      if (!prevBtn) return;

      var hasOverflow = row.scrollWidth > row.clientWidth + OVERFLOW_TOLERANCE;
      prevBtn.hidden = !hasOverflow;
      nextBtn.hidden = !hasOverflow;
      if (!hasOverflow) return;

      var atStart = row.scrollLeft <= OVERFLOW_TOLERANCE;
      var atEnd = row.scrollLeft + row.clientWidth >= row.scrollWidth - OVERFLOW_TOLERANCE;

      prevBtn.disabled = atStart;
      prevBtn.setAttribute('aria-disabled', String(atStart));
      nextBtn.disabled = atEnd;
      nextBtn.setAttribute('aria-disabled', String(atEnd));
    }

    function onScroll() {
      // setTimeout statt requestAnimationFrame: rAF pausiert in Tabs, die der
      // Browser als nicht sichtbar einstuft (Prerendering, Hintergrund-Tab),
      // ein einfaches Zeit-Throttle bleibt davon unabhängig zuverlässig.
      if (scrollTicking) return;
      scrollTicking = true;
      setTimeout(function () {
        updateButtons();
        scrollTicking = false;
      }, 100);
    }

    function onResize() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(updateButtons, 150);
    }

    function enable() {
      if (prevBtn) return;

      prevBtn = createButton('previous');
      nextBtn = createButton('next');
      row.appendChild(prevBtn);
      row.appendChild(nextBtn);

      prevBtn.addEventListener('click', function () {
        row.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      nextBtn.addEventListener('click', function () {
        row.scrollBy({ left: step(), behavior: 'smooth' });
      });

      row.addEventListener('scroll', onScroll);
      window.addEventListener('resize', onResize);
      updateButtons();
    }

    function disable() {
      if (!prevBtn) return;

      row.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onResize);
      row.removeChild(prevBtn);
      row.removeChild(nextBtn);
      prevBtn = null;
      nextBtn = null;
    }

    function sync(matches) {
      if (matches) {
        enable();
      } else {
        disable();
      }
    }

    sync(desktopMq.matches);

    if (desktopMq.addEventListener) {
      desktopMq.addEventListener('change', function (e) {
        sync(e.matches);
      });
    } else if (desktopMq.addListener) {
      // Ältere Safari-Versionen ohne addEventListener auf MediaQueryList.
      desktopMq.addListener(function (e) {
        sync(e.matches);
      });
    }
  }

  function handleContainer(container) {
    var row = container.querySelector(ROW_SELECTOR);
    if (!row || !row.querySelector(TILE_SELECTOR)) return; // AJAX-Inhalt noch nicht da
    setupSlider(row);
  }

  document.querySelectorAll(CONTAINER_SELECTOR).forEach(function (container) {
    handleContainer(container);

    var mo = new MutationObserver(function () {
      handleContainer(container);
    });
    mo.observe(container, { childList: true, subtree: true });
  });
})();

/* Bild-Links in Produktbeschreibung/technischen Daten als Overlay statt neuem Tab (Nutzer 01.11.2026).
   Gleicher Aufbau wie das Versandkosten-Overlay (dialog, Schliessen-X oben rechts); ohne JS bleibt der normale Link. */
(function () {
  var BILD = /\.(jpe?g|png|webp|gif)(\?|#|$)/i;
  var dlg;
  function oeffnen(url, titel) {
    if (!dlg) {
      dlg = document.createElement('dialog');
      dlg.id = 'tm-bild-overlay';
      dlg.style.cssText = 'overflow:hidden;width:95%;max-width:1100px;max-height:90vh;border:none;border-radius:8px;box-shadow:0 10px 30px rgba(0,0,0,0.5);padding:0;';
      dlg.innerHTML = '<div style="text-align:right;padding:10px 15px;background:#fff;border-bottom:1px solid #eee;position:sticky;top:0;z-index:10;">'
        + '<button type="button" aria-label="Schließen" style="background:none;border:none;font-size:28px;line-height:1;cursor:pointer;color:#333;">&times;</button></div>'
        + '<div style="padding:10px;overflow:auto;max-height:calc(90vh - 55px);text-align:center;"><img alt="" style="max-width:100%;height:auto;display:inline-block;"></div>';
      document.body.appendChild(dlg);
      dlg.querySelector('button').addEventListener('click', function () { dlg.close(); });
      dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    }
    var img = dlg.querySelector('img');
    img.src = url;
    img.alt = titel || '';
    dlg.showModal();
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || !BILD.test(a.getAttribute('href')) || a.closest('[data-product-media], .product-gallery, .product__media')) return;
    if (typeof HTMLDialogElement === 'undefined') return;
    e.preventDefault();
    oeffnen(a.href, a.textContent.trim());
  });
})();

/* Black-Week-Hinweis (Nutzer 02.11.2026, snippets/black-week-hinweis.liquid): beim Variantenwechsel neu pruefen, ob die
   angezeigte Variante mindestens data-mindest % unter der UVP liegt. Liest die Preise, die das Theme gerade anzeigt. */
(function () {
  function betrag(el) {
    if (!el) return 0;
    var t = (el.textContent || '').replace(/[^\d,]/g, '').replace(',', '.');
    return parseFloat(t) || 0;
  }
  function pruefen(box) {
    var bereich = box.closest('[data-product-pricing]');
    if (!bereich) return;
    var vergleich = bereich.querySelector('.price__compare-at.visible [data-price-compare], .price__compare-at.visible [data-price-original]');
    var preis = betrag(bereich.querySelector('[data-price-container] [data-price]'));
    var uvp = betrag(vergleich);
    var mindest = Number(box.getAttribute('data-mindest')) || 15;
    box.hidden = !(uvp > preis && preis > 0 && (uvp - preis) / uvp * 100 >= mindest);
  }
  document.querySelectorAll('[data-tm-black-week]').forEach(function (box) {
    var bereich = box.closest('[data-product-pricing]');
    if (!bereich || !window.MutationObserver) return;
    new MutationObserver(function () { pruefen(box); }).observe(bereich, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class'] });
  });
})();
